// Movimiento de la tienda. Sin este archivo todo sigue visible y usable.
(() => {
  const calma = matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!customElements.get('ao-carrusel')) {
    customElements.define('ao-carrusel', class extends HTMLElement {
      connectedCallback() {
        this.fotos = [...this.querySelectorAll('.ao-hero__foto')];
        if (this.fotos.length < 2) return;
        this.i = 0;
        this.pausado = calma;
        const control = this.querySelector('.ao-hero__control');
        const boton = this.querySelector('.ao-hero__pausa');
        control.hidden = false;
        const pintar = () => {
          boton.textContent = this.pausado ? '▶' : 'II';
          boton.setAttribute('aria-label', this.pausado ? 'Reanudar fotos' : 'Pausar fotos');
        };
        pintar();
        boton.addEventListener('click', () => { this.pausado = !this.pausado; pintar(); });
        this.addEventListener('mouseenter', () => { this.encima = true; });
        this.addEventListener('mouseleave', () => { this.encima = false; });
        this.reloj = setInterval(() => {
          if (!this.pausado && !this.encima && !document.hidden) this.mostrar((this.i + 1) % this.fotos.length);
        }, 4500);
      }
      disconnectedCallback() { clearInterval(this.reloj); }
      mostrar(n) {
        this.fotos.forEach((f, k) => {
          const activa = k === n;
          f.classList.toggle('is-activa', activa);
          if (activa) { f.removeAttribute('tabindex'); f.removeAttribute('aria-hidden'); f.querySelector('img')?.setAttribute('loading', 'eager'); }
          else { f.tabIndex = -1; f.setAttribute('aria-hidden', 'true'); }
        });
        this.i = n;
      }
    });
  }

  const aparecer = () => {
    if (calma || !('IntersectionObserver' in window)) return;
    const piezas = document.querySelectorAll('#MainContent .ao-seccion, #MainContent .product-card, #MainContent .ao-banda');
    const ojo = new IntersectionObserver((entradas) => {
      entradas.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.classList.add('ao-visto');
        ojo.unobserve(e.target);
      });
    }, { threshold: 0 });
    piezas.forEach((p, n) => {
      if (p.getBoundingClientRect().top < innerHeight * 0.9) return;
      p.style.setProperty('--ao-retardo', `${(n % 4) * 70}ms`);
      p.classList.add('ao-revela');
      ojo.observe(p);
    });
    // Seguro: nada queda oculto aunque el navegador no avise a tiempo.
    const mostrarTodo = () => document.querySelectorAll('.ao-revela:not(.ao-visto)').forEach((p) => {
      if (p.getBoundingClientRect().top < innerHeight) p.classList.add('ao-visto');
    });
    addEventListener('scroll', mostrarTodo, { passive: true });
    setInterval(mostrarTodo, 1500);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', aparecer);
  else aparecer();
})();

// Fotos de las tarjetas: se descargan antes de pasar el mouse, para que nunca quede un espacio en blanco.
(() => {
  if (!('IntersectionObserver' in window)) return;
  const vistas = new WeakSet();
  const ojo = new IntersectionObserver((entradas) => {
    entradas.forEach((e) => {
      if (!e.isIntersecting) return;
      ojo.unobserve(e.target);
      e.target.querySelectorAll('img[loading="lazy"]').forEach((i) => {
        i.loading = 'eager';
        i.decoding = 'sync';
        if (i.decode) i.decode().catch(() => {});
      });
    });
  }, { rootMargin: '1200px 0px' });
  const buscar = () => document.querySelectorAll('.product-card').forEach((c) => {
    if (vistas.has(c)) return;
    vistas.add(c);
    ojo.observe(c);
  });
  const iniciar = () => {
    buscar();
    let espera;
    new MutationObserver(() => { clearTimeout(espera); espera = setTimeout(buscar, 150); }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
